export var jsonHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};
export var jwtHeader = function jwtHeader(token) {
  if (token) {
    return {
      Authorization: token,
      AuthType: 'Signature'
    };
  }
};
export var httpHeaders = function httpHeaders(token) {
  return Object.assign({}, jsonHeaders, jwtHeader(token));
};